import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
  <p><strong>Description</strong></p>
  <p>This action triggers when a Stow Associate incorrectly Stows 10+ Non-Oversized packages to Oversized Racks. Non-Oversized packages are packages that do not have “Oversized” on the SLAM label.&nbsp;</p>
  <p><strong>Impact</strong></p>
  <p>The Oversized package rack is reserved for packages with “OVERSIZED” on the SLAM label. By stowing non-oversized packages to the OV rack, sites may see their oversized rack get overfilled which leads to:</p>
  <ul>
      <li>Increased time spent picking routes (77.52 additional seconds per extra package in the OV stow area)&nbsp;</li>
      <li>Increased time spent loading Vans (14.12 additional seconds per extra package in the OV stow area)</li>
  </ul>
  <p>
      This action encourages an L3+ Leader to perform the <span className="wikiinternallink"><a href="https://apollo-audit.corp.amazon.com/audits/new?audit_type_id=3357">SCC Work Item - Non OV to OV</a></span> Audit in Apollo with the
      associate to help direct the seek to understand conversation on why the associate is stowing non-oversized packages to the oversized rack.&nbsp;
  </p>
  <p><strong>Resolution Steps</strong></p>
  <p>
      1.Locate the Stow Associate that triggered the Alert. &nbsp;<br />
      2.Conduct the <span className="wikiinternallink"><a href="https://apollo-audit.corp.amazon.com/audits/new?audit_type_id=3357">SCC Work Item - Non OV to OV</a></span> Audit in Apollo<br />
      3.After completing the audit, close the action&nbsp;&nbsp;
  </p>
  <div className="wikimodel-emptyline"></div>
  <p><strong>Supplemental Links</strong></p>
  <p>
      1.
      <span className="wikiinternallink">
          <a
              href="https://us-east-1.quicksight.aws.amazon.com/sn/dashboards/5571ef06-acb5-4bae-a3ed-5d19a4859a62/sheets/5571ef06-acb5-4bae-a3ed-5d19a4859a62_2275a8a3-aa88-429c-91ea-77b6a5aedb77?directory_alias=amzlbiaquicksight&amp;qs-signin-user-auth=false#"
          >
              FPY Dashboard
          </a>
      </span>
      <br />
      2.<span className="wikiinternallink"><a href="https://apollo-audit.corp.amazon.com/audits/new?audit_type_id=3357">SCC Work Item - Non OV to OV</a></span> Audit in Apollo<br />
      3.
      <span className="wikiinternallink">
          <a href="https://us-east-1.quicksight.aws.amazon.com/sn/dashboards/e5996fbe-2141-490a-adad-d5e8819be562/sheets/e5996fbe-2141-490a-adad-d5e8819be562_012c3736-bc21-428a-a187-996fe2ea26c2">
              NA AMZL Manager (SCC &amp; GCA) Alert Qicksight Dashboard
          </a>
      </span>
  </p>
</div>
`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Non_OV_To_OV.jsx